<button class="button" [ngClass]="{'next': next, 'cancel': cancel}">{{content}}</button>
